import { useEffect, useRef, useState } from 'react';
import './About.css';

const stats = [
  { value: 'CTESP', label: 'CTeSP em Desenvolvimento de Software – ESAN' },
  { value: 'Curso Profissional', label: 'Técnico de Informática – Soares Basto' },
  { value: '3x', label: 'Estágios Realizados' },
];

export default function About({ id }) {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [lineVisible, setLineVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setLineVisible(true), 100);
          setTimeout(() => setVisible(true), 300);
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-container" id={id} ref={sectionRef}>

      <div className={`section-label ${visible ? 'section-label--visible' : ''}`}>
        <span>02</span>
        <span>SOBRE MIM</span>
      </div>

      <div className={`section-line ${lineVisible ? 'section-line--visible' : ''}`} />

      <div className="about-inner">

        <div className="about-left">
          <h2 className={`section-title ${visible ? 'section-title--visible' : ''}`}>
            <span>Construo</span>
            <span className="text-outline">experiências</span>
            <span>digitais.</span>
          </h2>

          <div className="about-stats">
            {stats.map((s, i) => (
              <div
                key={s.label}
                className={`about-stat ${visible ? 'about-stat--visible' : ''}`}
                style={{ transitionDelay: `${0.5 + i * 0.15}s` }}
              >
                <span className="about-stat-value">{s.value}</span>
                <span className="about-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="about-right">
          <p className={`about-text ${visible ? 'about-text--visible' : ''}`} style={{ transitionDelay: '0.35s' }}>
            Sou um developer em início de carreira, apaixonado por criar interfaces
            que combinam estética e funcionalidade. Formado em Curso Profissional
            e CTESP de Desenvolvimento de Software.
          </p>
          <p className={`about-text ${visible ? 'about-text--visible' : ''}`} style={{ transitionDelay: '0.5s' }}>
            Tenho experiência prática adquirida em estágios, onde trabalhei em
            projetos reais e aprendi a importância dos detalhes que fazem a diferença
            entre um produto bom e um produto extraordinário.
          </p>

        </div>

      </div>

      <div className={`section-line section-line--bottom ${lineVisible ? 'section-line--visible' : ''}`} />
    </div>
  );
}